(function() {
	'use strict';

	angular.module('onboarding.common')
		.service('usurpService', usurpService);

	usurpService.$inject = ['$http', 'USURP_LS'];

	var modal,
		validationFrequency,
		isUsurpedFromLogin;

	function usurpService($http, USURP_LS) {
		var baseUsurpUrl = '../api/usurp/';

		return {
			getUsurpSessionState: getUsurpSessionState,
			usurpSession: usurpSession,
			checkUsurpRegular: checkUsurpRegular,
			handleUsurpState: handleUsurpState,
			removeUsurpLSKey: removeUsurpLSKey,
			getTimeInterval: getTimeInterval,
			closeModal: closeModal
		};

		function getUsurpSessionState() {
			var url = baseUsurpUrl + 'getsessionstate';

			return $http.get(url)
				.then(function(result) {
					if (result) {
						return result.data.isUsurped;
					}
				})
				.catch(function() {
					return false;
				});
		}

		function usurpSession() {
			var url = baseUsurpUrl + 'usurpsession';

			return $http.post(url);
		}

		function checkUsurpRegular() {
			isUsurpedFromLogin = isUserJustLogin();
			setTimeInterval();

			setTimeout(function() {
				handleUsurpState()
					.then(function(shouldScheduleCheck) {
						if (shouldScheduleCheck) {
							localStorage.setItem(USURP_LS.TIMESTAMP, Number(Date.now()));
							checkUsurpRegular();
						}
					}).catch(function() {
						localStorage.setItem(USURP_LS.TIMESTAMP, Number(Date.now()));
						checkUsurpRegular();
					});
			}, validationFrequency);
		}

		function handleUsurpState() {
			return getUsurpSessionState()
				.then(function(isUsurped) {
					if (!isUsurped) {
						localStorage.setItem(USURP_LS.IS_FROM_LOGIN, false);

						return true;
					}

					if (isUsurpedFromLogin) {
						modal = $('#promptUsurpModalContainer');
						showDialog('Oops!', modal);
					} else {
						modal = $('#sessionUsurpedModalContainer');
						showDialog('Uh Oh!', modal);
					}

					return false;
				});
		}

		function getTimeInterval() {
			var timeNow = Number(Date.now());
			var lastUsurpCheck = parseInt(localStorage.getItem(USURP_LS.TIMESTAMP), 10);

			return !lastUsurpCheck ? 0 : timeNow - lastUsurpCheck;
		}

		function setTimeInterval() {
			var defaultValidationFrequency = 180000, // 3 min
				immediatelyCheckUsurp = 0;

			validationFrequency = isUsurpedFromLogin || defaultValidationFrequency < getTimeInterval()
				? immediatelyCheckUsurp
				: defaultValidationFrequency - getTimeInterval();
		}

		function isUserJustLogin() {
			var fromLogin = localStorage.getItem(USURP_LS.IS_FROM_LOGIN);

			return fromLogin === null || JSON.parse(fromLogin);
		}

		function showDialog(titleModal, modal) {
			modal.dialog({
				title: titleModal,
				modal: true,
				width: '30vw',
				resizable: false,
				show: { effect: 'fade', duration: 300 },
				hide: { effect: 'fade', duration: 300 },
				draggable: false,
				dialogClass: 'usurp-modal',
				closeOnEscape: false,
				zIndex: 2000
			});
			
			applyStyles(modal);
		}

		function applyStyles(modal) {
			var modalWrapper = modal.parent();

			$(window).resize(function () {
				modalWrapper.css({
					left: window.innerWidth / 2 - modal.width() / 2,
					top: window.innerHeight / 2 - modal.height() / 2,
				});
			});
		}

		function removeUsurpLSKey() {
			if(!localStorage.getItem(USURP_LS.IS_FROM_LOGIN)) {
				return;
			}

			localStorage.removeItem(USURP_LS.IS_FROM_LOGIN);
		}

		function closeModal() {
			modal.dialog('close');
		}
	}
})();
